import { FC, useState } from 'react'

import { Link, useLocation } from 'react-router-dom'
import { ContainerHeader } from 'components/container'
import { Share } from '../share'
import { IconHome } from '../../../components/icons/home'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import { config } from 'config'
import { LogoRU } from './logoRU'
import { StyledHeader, Logo, LogoContainer, Lang, Home } from './styled'

export const Header: FC<{
  onTop?: boolean
  isTransparent: boolean
  inverted: boolean
}> = () => {
  const isLarge = useMedia([breakpoints.medium], [true], false)
  const [isShareExpanded, setShareExpanded] = useState(false)
  const isVisible = isLarge || !isShareExpanded
  const location = useLocation()

  return (
    <>
      <StyledHeader>
        <ContainerHeader $fluid>
          <LogoContainer
            animate={{
              opacity: isVisible ? 1 : 0,
              transition: { delay: isVisible ? 0.3 : 0 },
            }}
            href="/"
          >
            {config.language === 'ua' ? <Logo /> : <Logo as={LogoRU} />}
          </LogoContainer>

          <div>
            <Home
              $active={location.pathname === '/'}
              animate={{
                opacity: isVisible ? (location.pathname === '/' ? 0.3 : 1) : 0,
                transition: { delay: isVisible ? 0.4 : 0 },
              }}
            >
              {location.pathname === '/' ? (
                <IconHome />
              ) : (
                <Link to="/">
                  <IconHome />
                </Link>
              )}
            </Home>

            <Lang
              animate={{
                opacity: isVisible ? 1 : 0,
                transition: { delay: isVisible ? 0.4 : 0 },
              }}
            >
              <li>
                {config.language === 'ua' ? (
                  'Укр'
                ) : (
                  <a href={config.linkUa}>Укр</a>
                )}
              </li>
              <li>
                {config.language === 'ru' ? (
                  'Ру'
                ) : (
                  <a href={config.linkRu}>Ру</a>
                )}
              </li>
            </Lang>
            <Share
              isShare
              onOpen={() => setShareExpanded(true)}
              onClose={() => setShareExpanded(false)}
            />
          </div>
        </ContainerHeader>
      </StyledHeader>
    </>
  )
}
